import { Modal2 } from 'components/Modal'
import { formatDistance } from 'date-fns'
import { Link } from 'gatsby'
import { toFriendlyKitId, toFriendlyRecoveryCertificateId } from 'helpers/string'
import { useState } from 'react'
import urlForItem from './urlForItem'
import {
  AdminSearchQuery_adminSearch,
  AdminSearchQuery_adminSearch_results_EmailVerification,
  AdminSearchQuery_adminSearch_results_Kit,
  AdminSearchQuery_adminSearch_results_Order,
  AdminSearchQuery_adminSearch_results_RecoveryCertificate,
} from './__generated__/AdminSearchQuery'

const KitResultRow = ({ kit, onClick }: { kit: AdminSearchQuery_adminSearch_results_Kit; onClick: () => void }) => {
  return (
    <div className="is-flex mb-3">
      <div>
        <Link onClick={onClick} to={urlForItem(kit)}>
          <strong>Kit </strong>
          {toFriendlyKitId(kit.id)}
        </Link>
      </div>

      <div className="ml-4">
        {kit.sku}, {kit.status} ({kit.registrationInfo?.firstName} {kit.registrationInfo?.lastName},{' '}
        {kit.registrationInfo?.email})
      </div>
    </div>
  )
}

const OrderResultRow = ({
  order,
  onClick,
}: {
  order: AdminSearchQuery_adminSearch_results_Order
  onClick: () => void
}) => {
  return (
    <div className="is-flex mb-3">
      <div>
        <Link onClick={onClick} to={urlForItem(order)}>
          <strong>Order </strong>
          {order.id}
        </Link>
      </div>

      <div className="ml-4">{order.paymentStatus}</div>
    </div>
  )
}

const RecoveryCertificateResultRow = ({
  recoveryCertificate,
  onClick,
}: {
  recoveryCertificate: AdminSearchQuery_adminSearch_results_RecoveryCertificate
  onClick: () => void
}) => (
  <div className="is-flex mb-3">
    <div>
      <Link onClick={onClick} to={urlForItem(recoveryCertificate)}>
        <strong>Recovery Certificate </strong>
        {toFriendlyRecoveryCertificateId(recoveryCertificate.orderId)}
      </Link>
    </div>

    <div className="ml-4">{recoveryCertificate.paymentStatus}</div>
  </div>
)

const EmailVerificationRow = ({
  emailVerification,
}: {
  emailVerification: AdminSearchQuery_adminSearch_results_EmailVerification
}) => {
  return (
    <div className="is-flex mb-3">
      <div>Email Verification</div>

      <div className="ml-4">
        Code: <strong>{emailVerification.code}</strong>
      </div>

      <div className="ml-4">
        Expires in:{' '}
        <strong>
          {formatDistance(new Date(emailVerification.expiresAt * 1000), new Date(), {
            addSuffix: true,
          })}
        </strong>
      </div>
    </div>
  )
}

const SearchResultsModal = ({
  adminSearch,
  onRequestClose,
}: {
  adminSearch: AdminSearchQuery_adminSearch
  onRequestClose: () => void
}) => {
  const [hideCompleted, setHideCompleted] = useState(false)

  return (
    <Modal2
      isOpen={true}
      onRequestClose={onRequestClose}
      header={
        <>
          Search Results (searched {adminSearch.assumedInputType} &ldquo;
          <span className="is-family-monospace has-text-primary">{adminSearch.input}</span>
          &rdquo;)
        </>
      }
    >
      <div className="has-text-right">
        <label className="checkbox">
          <input
            type="checkbox"
            onChange={(e) => setHideCompleted(e.target.checked)}
            value={hideCompleted && 'checked'}
          />{' '}
          Hide completed kits
        </label>
      </div>

      <hr className="has-height-05px has-background-grey-light my-3" />

      {adminSearch.results
        .filter((result) => {
          if (!hideCompleted) return true

          return result.__typename === 'Kit' && result.status !== 'COMPLETED'
        })
        .map((result) => {
          if (result.__typename === 'Kit') {
            return <KitResultRow key={result.id} onClick={onRequestClose} kit={result} />
          }

          if (result.__typename === 'Order') {
            return <OrderResultRow key={result.id} onClick={onRequestClose} order={result} />
          }

          if (result.__typename === 'EmailVerification') {
            return <EmailVerificationRow key={result.id} emailVerification={result} />
          }

          if (result.__typename === 'RecoveryCertificate') {
            return (
              <RecoveryCertificateResultRow key={result.id} onClick={onRequestClose} recoveryCertificate={result} />
            )
          }

          return <p key={result.id}>Something else</p>
        })}
    </Modal2>
  )
}

export default SearchResultsModal
// DYS0Y5PF
